import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import OVRSApplicationContent from './OVRSApplicationContent';

const form = {
  keyword: '',
  transaction_status: '',
};

const statusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'COMPUTED', value: 'COMPUTED' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'CANCELLED', value: 'CANCELLED' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'PAID', value: 'PAID' },
];

function OVRSApplicationContainer({
  match,
  history,
  getOvrsTransactions,
  ovrsList,
  ovrsListPager,
  isLoading,
  removeUserManagement,
  showTransaction,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const param = {
    module_type: 'OVRS',
    transaction_type: 'OVR PAYMENT',
    q: formData.keyword,
    sort_by: 'asc',
    transaction_status: filter.transaction_status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeUserManagement(data.id, () => {
          getOvrsTransactions(
            {
              module_type: 'OVRS',
              transaction_type: 'OVR PAYMENT',
            },
            (response) => {
              const id = _.get(response, 'data.0.id');
              history.push(`/important-notification/${id}`);
              showTransaction(id);
            }
          );
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getOvrsTransactions({
      module_type: 'OVRS',
      transaction_type: 'OVR PAYMENT',
    });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getOvrsTransactions({
        module_type: 'OVRS',
        transaction_type: 'OVR PAYMENT',
        q: formData.keyword,
        sort_by: 'desc',
      });
    } else {
      getOvrsTransactions({
        module_type: 'OVRS',
        transaction_type: 'OVR PAYMENT',
        sort_by: 'desc',
      });
    }
  }, [debouncedSearchTerm]);

  const onSetStatusFilter = () => e => {
    setFilter({
      ...filter,
      transaction_status: e.value,
    });
    getOvrsTransactions(
      {
        ...param,
        transaction_status: e.value, // status
      },
      (response) => {
        if (_.get(response, 'data').length > 0) {
          const id = _.get(response, 'data.0.id');
          history.push(
            `/ordinance-violation-receipts/violations/search/${id}`
          );
          showTransaction(id);
        }
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:ovrsId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            setParams={param}
            getData={getOvrsTransactions}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:ovrsId?`}
            listName="OVRS Transactions"
            label="OVRS Transactions"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <span className="text-uppercase"> {_.get(item, 'attributes.name')} </span>
              </div>
            )}
            isLoading={isLoading}
            setStatusFilter={onSetStatusFilter('transaction_status')}
            statusFilter
            statusOptions={statusOptions}
            status={_.get(filter, 'transaction_status') || ''}
            selected={params.ovrsId}
            data={ovrsList}
            dataPager={ovrsListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:ovrsId?`}
                    render={() => (
                      <OVRSApplicationContent handleRemove={handleRemove} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:ovrsId?`}
                  render={() =>
                    !params.ovrsId && ovrsList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(ovrsList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

OVRSApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getOvrsTransactions: PropTypes.instanceOf(Function).isRequired,
  ovrsList: PropTypes.instanceOf(Array).isRequired,
  ovrsListPager: PropTypes.instanceOf(Object).isRequired,
  removeUserManagement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  ovrsList: _.get(api, `${c.GET_OVR_TRANSACTIONS}.list`) || [],
  ovrsListPager: _.get(api, `${c.GET_OVR_TRANSACTIONS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_OVR_TRANSACTIONS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OVRSApplicationContainer);
